import React from "react";
import AceEditor from "react-ace";
import "ace-builds/webpack-resolver";
import "ace-builds/src-noconflict/mode-python";
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/theme-github";
import "ace-builds/src-noconflict/ext-language_tools";
import Tooltip from "@/component/Tooltip";
import { CloseIcon } from "@/assets/svgs/icons";


export const CODE_EDITOR_DEFAULT_CODE = `
def main(context_value):
    dict = { 'a' : 'abcd' }
    # ADD PYTHON CODE HERE
    return dict
`;

interface CodeEditorProps {
    mode: string;
    value?: string;
    defaultValue?: string;
    height: string;
    inValid?: boolean;
    invalidMessage?: string;
    onChange: (value: string) => void;
}

const CodeEditor: React.FC<CodeEditorProps> = (props) => {
    const {
        mode,
        value,
        defaultValue,
        height,
        inValid,
        invalidMessage,
        onChange
    } = props;

    return (
        <div data-testid="code-editor"
             className="relative"
        >
            {inValid && (
                <Tooltip placement="top"
                        message={invalidMessage}
                >
                    <div className="absolute -left-5 bg-point-red rounded-[2px] z-50">
                        <CloseIcon className="size-3 text-white" />
                    </div>
                </Tooltip>
            )}
            <AceEditor mode={mode}
                    theme="github"
                    name={`${mode}_code_editor`}
                    editorProps={{
                        $blockScrolling: true
                    }}
                    value={value}
                    defaultValue={defaultValue}
                    showPrintMargin={false}
                    width="100%"
                    height={height}
                    onChange={onChange}
                    setOptions={{
                        enableKeyboardAccessibility: true
                    }}
            />
        </div>
    );
};

export default CodeEditor;
